"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importUserCoupon = importUserCoupon;
exports.uploadImportFile = uploadImportFile;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 导入用户+优惠券

// 上传文件
function uploadImportFile(data) {
  return (0, _request.default)({
    url: '/admin/upload/file',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: data
  });
}

// 触发后端导入
function importUserCoupon(data) {
  return (0, _request.default)({
    url: '/admin/import/user-coupon',
    method: 'post',
    data: data
  });
}